module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e5451eaac705d1385e4b0dbabe938e3d.png";